import React from 'react'

import './Footer.scss';

const Footer = () => {
    return (
        <footer>
            <p><b>Szűcs Tamás 2022 &copy;</b></p>
            <p>My very first web application in React:)</p>
        </footer>
    )
}

export default Footer